import { Button, message, Popconfirm, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Trash } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SysUserRoleService, UserInRole } from "../../../../../services/config/qltl-config/sysUserRole";
import UserRoleForm from "./user-role-form";

interface UsersInRoleProps {
  roleId: string;
  open: boolean;
}

const UsersInRole = (props: UsersInRoleProps) => {
  const { roleId, open } = props;

  const [users, setUsers] = useState<UserInRole[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isDeleting, setDeleting] = useState(false);

  const fetchListUsersInRole = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await SysUserRoleService.getListUsersInRole(roleId);

      if (res) {
        setUsers(res);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [roleId]);

  const handleDeleteUserInRole = useCallback(
    async (userId: string) => {
      setDeleting(true);

      try {
        await SysUserRoleService.deleteUserRole(userId);
        await fetchListUsersInRole();

        message.success("Xóa người dùng thành công!");
      } catch (error) {
        message.error((error as Error)?.message || "Xóa người dùng thất bại!");
      } finally {
        setDeleting(false);
      }
    },
    [fetchListUsersInRole],
  );

  const columns: ColumnsType<UserInRole> = useMemo(
    () => [
      {
        title: "Mã nhân viên",
        dataIndex: "hrId",
        key: "hrId",
        fixed: "left",
      },
      {
        title: "Họ tên",
        dataIndex: "fullName",
        key: "fullName",
        fixed: "left",
      },
      {
        title: "Account",
        dataIndex: "username",
        key: "username",
        fixed: "left",
      },
      {
        title: "",
        dataIndex: "id",
        key: "id",
        fixed: "left",
        render: (value, record) => (
          <Popconfirm
            title={`Bạn có chắc chắn muốn xóa ${record.fullName}?`}
            onConfirm={() => handleDeleteUserInRole(value)}
            okText="Xóa"
            cancelText="Hủy"
            okButtonProps={{
              danger: true,
            }}
          >
            {/* <Button danger>Delete</Button> */}
            <Button danger type="text" icon={<Trash size={16} />} loading={isDeleting} />
          </Popconfirm>
        ),
      },
    ],
    [handleDeleteUserInRole, isDeleting],
  );

  useEffect(() => {
    if (roleId) fetchListUsersInRole();
  }, [fetchListUsersInRole, roleId]);

  return (
    <div>
      <UserRoleForm open={open} roleId={roleId} refresh={fetchListUsersInRole} />
      <Table loading={isLoading} columns={columns} dataSource={users} />
    </div>
  );
};

export default UsersInRole;
